import { ProfileResource } from "@medplum/core";
import { BundleEntry, ExtractResource } from "@medplum/fhirtypes";
import { createAction } from "@reduxjs/toolkit";

export const updateProfile = createAction<ProfileResource | undefined>(
  "UPDATE_PROFILE"
);
export const reset = createAction("RESET");
